<template>
  <div id="user-profile">
    <div class="user-details">
      <v-btn
       v-if="firstOrganization.active"
        class="edit-btn"
        fab
        small
        color="#FFF"
        to="/profile/update"
        elevation="0"
      >
        <v-icon color="black">
          mdi-file-edit-outline
        </v-icon>
      </v-btn>
      <div class="user-name-and-image">
        <img
          :src="getImageUrl"
          alt=""
          width="80px"
        >
        <div class="name-container">
          <h2 class="header-style">
            {{ userDetails.first_name }} {{ userDetails.last_name }}
          </h2>
          <v-btn
            v-if="isActiveCheckInDetailsFetched"
            x-small
            class="active-btn"
            elevation="0"
          >
            Onsite
          </v-btn>
        </div>
      </div>
      <p class="mt-4 title-text-style">
        Email:
        <font
          v-if="userDetails.email !== null"
          class="value-text-style"
          style="text-transform: lowercase"
        >
          {{ userDetails.email }}
        </font>
        <font
          v-else
          class="value-text-style"
        >
          N/A
        </font>
      </p>
      <p class="title-text-style">
        Phone:
        <font class="value-text-style">
          {{ userDetails.phone_number }}
        </font>
      </p>

      <v-btn
        v-if="firstOrganization.active"
        color="#64CA7F"
        class="btn-style-action-proceed"
        small
        rounded
        elevation="0"
        @click="emergencyContacts()"
      >
        <font> Emergency Contacts </font>
        <v-icon small>
          mdi-chevron-right
        </v-icon>
      </v-btn>
    </div>
    <div>
      <v-btn
        v-if="firstOrganization.active"
        elevation="0"
        class="profile-buttons"
        @click="toOrganization()"
      >
        <v-icon> mdi-sitemap </v-icon>
        <font class="pl-3">
          My Organizations
        </font> <v-spacer />
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn
        v-if="firstOrganization.active"
        elevation="0"
        class="profile-buttons"
        @click="toProjects()"
      >
        <v-icon> mdi-domain </v-icon>
        <font class="pl-3">
          Projects
        </font> <v-spacer />
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn

        v-if="isSiteManager && firstOrganization.active"
        elevation="0"
        class="profile-buttons"
        @click="toAttendance()"
      >
        <v-icon> mdi-format-list-checks </v-icon>
        <font class="pl-3">
          Attendance
        </font> <v-spacer />
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn
        v-if="!workerCheck && firstOrganization.active"
        elevation="0"
        class="profile-buttons"
        @click="toWorkers()"
      >
        <v-icon> mdi-account-hard-hat </v-icon>
        <font class="pl-3">
          Workers
        </font> <v-spacer />
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <!-- <v-btn
        v-if="!workerCheck"
        elevation="0"
        class="profile-buttons"
        @click="toInvoices()"
      >
        <v-icon> mdi-text-box-multiple-outline </v-icon>
        <font class="pl-3">
          Invoices
        </font> <v-spacer />
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn> -->
      <!-- <v-btn
      v-if="isSiteManager"
        elevation="0"
        class="profile-buttons"
        @click="toSchedules()"
      >
        <v-icon> mdi-clipboard-text-outline</v-icon>
        <font class="pl-3">
          Schedules
        </font> <v-spacer />
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn> -->
      <v-btn
        elevation="0"
        class="profile-buttons"
        @click="toActivities()"
      >
        <v-icon> mdi-text-account </v-icon>
        <font class="pl-3">
          My Activities
        </font> <v-spacer />
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn
        v-if="firstOrganization.active"
        elevation="0"
        class="profile-buttons"
        @click="toDocuments()"
      >
        <v-icon> mdi-file-document-outline </v-icon>
        <font class="pl-3">
          My Documents
        </font> <v-spacer />
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn
        elevation="0"
        class="profile-buttons"
        @click="logout()"
      >
        <v-icon color="#C62828">
          mdi-logout
        </v-icon>
        <font
          class="pl-3"
          color="#C62828"
        >
          Log out
        </font> <v-spacer />
        <v-icon color="red">
          mdi-chevron-right
        </v-icon>
      </v-btn>
    </div>
    <emergency-contacts
      v-if="showEmergencyContacts"
      @closed="showEmergencyContacts = false"
    />
    <alert-dialog
      v-if="showLogoutAlert"
      :title="'Confirm Log out'"
      :message="'Are you sure you want to log out of the app ?'"
      @closed="showLogoutAlert = false"
      @confirmed="logoutConfirmed()"
    />
    <centre-spinner :loading="loading" />
    <div
      v-if="appVersion !== null || appVersion !== undefined "
      class="d-flex justify-center"
    >
      <font
        color="#000"
        size="1"
      >
        App Version - {{ appVersion }}
      </font>
    </div>
  </div>
</template>

<script>
import EmergencyContacts from './dialogComponents/EmergencyContacts.vue';
import spinner from 'src/views/components/SpinnerCentre';
import AlertDialog from 'src/views/components/AlertDialog.vue';
import Constants from 'src/constants';

export default {
  name: 'UserProfile',
  components: {
    'centre-spinner': spinner,
    'alert-dialog': AlertDialog,
    'emergency-contacts': EmergencyContacts,
  },
  data: () => ({
    loading: false,
    showLogoutAlert: false,
    showEmergencyContacts: false,
  }),
  computed: {
    userDetails () {
      return this.$store.getters['userprofile/getUserDetails'];
    },
    appVersion () {
     const data = localStorage.getItem('appVersion');
     return data;
    },
    firstOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    isActiveCheckInDetailsFetched () {
      if (Object.keys(this.activeCheckInDetails).length > 0) {
        return true;
      }
      return false;
    },
    getImageUrl () {
      const baseUrl = process.env.VUE_APP_STORAGE_API_URL;
      const image = this.userDetails.profile_image;
      if (image && image.file_path) {
        return `${baseUrl}/${image.file_path}`;
      }
      return require('../../../assets/img/user-profile.png');
    },
    workerCheck () {
      return (
        this.firstOrganization === null ||
        undefined ||
        this.firstOrganization.app_user_role === 'worker'
      );
    },
    isSiteManager () {
      return (
        this.firstOrganization === null ||
        undefined ||
        this.firstOrganization.app_user_role === 'site-manager'
      );
    },
  },
  async mounted () {
    this.loading = true;
    await this.fetchUserDetails();
    await this.fetchActiveCheckinDetails();
    this.loading = false;
  },
  methods: {
    async fetchUserDetails () {
      await this.$store.dispatch('userprofile/fetchUserDetails').then(() => {
        localStorage.setItem(
              'selectedOrganization',
              JSON.stringify(this.userDetails.selected_organization),
            );
      });
    },
    logout () {
      var checkInId = localStorage.getItem('checkIn');
      var userExist = localStorage.getItem('user');
      if (userExist === null) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Already signed out.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      if (checkInId !== null) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please checkout first.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.showLogoutAlert = true;
    },
    emergencyContacts () {
      this.showEmergencyContacts = true;
    },
    toOrganization () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Organizations' });
      }, 1000);
    },
    toProjects () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Organization Projects' });
      }, 1000);
    },
    toAttendance () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Attendence' });
      }, 1000);
    },
    toWorkers () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Workers' });
      }, 1000);
    },
    toInvoices () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Invoices' });
      }, 1000);
    },
    toActivities () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'User Activity' });
      }, 1000);
    },
    toDocuments () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Organization Documents' });
      }, 1000);
    },
    toSchedules () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Jobs' });
      }, 1000);
    },
    logoutConfirmed () {
      this.showLogoutAlert = false;
      this.$router.push({ name: 'Logout' });
    },
    async fetchActiveCheckinDetails () {
      await this.$store.dispatch('swiftuser/fetchUsersCurrentCheckInDetails');
    },
  },
};
</script>

<style scoped>
#user-profile {
  padding-bottom: 80px;
}
.user-name-and-image {
  display: flex;
  gap: 20px;
  align-items: center;
  position: relative;
}
.user-name-and-image img {
  border-radius: 100%;
}
.active-btn {
  text-transform: none;
  border-radius: 10px;
  background-color: rgba(137, 210, 137, 0.426) !important;
  color: rgba(5, 139, 5, 0.888);
  font-weight: 700;
  max-width: fit-content;
}
span {
  font-weight: bold;
}
.profile-buttons {
  background: transparent !important;
  color: #000000;
  text-transform: none !important;
  width: 100%;
  height: 50px !important;
  margin-top: 20px;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.user-details {
  position: relative;
}
.edit-btn {
  position: absolute;
  bottom: 0;
  right: 0;
}
.emergency-style {
  text-transform: none !important;
}
.name-container {
  display: flex;
  flex-direction: column !important;
}
</style>
